export const APPLICATIONS_PAUSED_MESSAGE =
  "We've temporarily paused new applications at the moment. If you'd like to register your interest in selling with us, please submit your email address below and one of the team will get back to you when our application form is available.";
export const REGISTERED_INTEREST_SUCCESSFULLY =
  'Thank you, you have successfully registered your interest.';
export const WE_WILL_BE_IN_TOUCH = 'We will be in touch in the coming weeks.';
